import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TripAccessService } from '../services/trip-access/trip-access.service';
import { TripService } from '../services/trip.service';

/** Finance-role users paying PPM (Money Out) — mobile route for `money-out-payment-panel`. */
export const moneyOutPaymentGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tripService = inject(TripService);
  const tripAccess = inject(TripAccessService);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  if (!tripAccess.context(trip)?.isFinance) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
